import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import TitleBar from "../../../partials/content/TitleBar";
import Pagination from "../../../partials/content/Pagination";

function AllBanner() {
  const [allCampaignBanner, setAllCampaignBanner] = useState();
  const [campaignIDSelected, setCampaignIDSelected] = useState();
  const [allAdvertiseBannerUsers, setAllAdvertiseBannerUsers] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getAllAdvertiseBannerUsers();
    getAllCampaignBanner();
  }, []);

  useEffect(() => {
    getAllAdvertiseBannerUsers();
  }, [currentPage, countItemPerPage]);

  const getAllAdvertiseBannerUsers = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allAdvertiseBannerUsers =
      await sendRequestGetAllAdvertiseBannerUsers();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (allAdvertiseBannerUsers.length == 0) {
      return;
    }
    setAllAdvertiseBannerUsers(allAdvertiseBannerUsers.advertises);
    setCountPage(allAdvertiseBannerUsers.count_page);
  };

  const generateDoesNotHaveAnyAdvertiseTag = () => {
    return (
      <>
        <div class="d-flex flex-column flex-md-row">
          <div class="text-center text-md-right">
            <img
              class="img-fluid"
              src="/assets/img/do-not-have-advertise.svg"
            />
          </div>
          <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p className="text-justify">شما هیچ تبلیغ بنری ندارید :(</p>
            <p className="text-justify">برای شروع کار یک تبلیغ بسازید.</p>
            <p className="text-justify">چگونه تبلیغ بسازم؟</p>
            <div>{generateButtonAddAdvertise()}</div>
          </div>
        </div>
      </>
    );
  };

  const sendRequestDeleteBannerAdvertise = async (advertiseBannerUserID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/banner/" +
          advertiseBannerUserID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
      case 3:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "ویرایش تبلیغ در حالت کمپین فعال";
        break;
    }

    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const generateAllAdvertiseBannerUsers = () => {
    return (
      <>
        {generateButtonAddAdvertise()}
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تبلیغ</td>
                <td>شماره کمپین</td>
                <td>نام کمپین</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ بروزرسانی</td>
                <td>آدرس فرود</td>
                <td>وضعیت</td>
                <td>بررسی</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAdvertiseBannerUsers.map((advertiseBannerUser, index) => {
                let classNameStateAdvertise = advertiseBannerUser.active
                  ? "success"
                  : "danger";
                let textStateAdvertise = advertiseBannerUser.active
                  ? "فعال"
                  : "غیر فعال";
                const [classNameConfirmAdvertise, textConfirmAdvertise] =
                  generateConfirmTag(advertiseBannerUser.confirm);

                return (
                  <tr key={index}>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(advertiseBannerUser.id)}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.campaign_id
                      )}
                    </td>

                    <td>{advertiseBannerUser.campaign_name}</td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.created_at
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.updated_at
                      )}
                    </td>
                    <td className=" text-center">
                      <a
                        className="btn btn-primary text-center"
                        target="_blank"
                        href={advertiseBannerUser.link}
                      >
                        <i className="fa fa-globe"></i>
                      </a>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameStateAdvertise} `}
                        >
                          {textStateAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameConfirmAdvertise}`}
                        >
                          {textConfirmAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/advertise/banner/edit/${advertiseBannerUser.id} `}
                            className="btn btn-success"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const sendRequestGetAllAdvertiseBannerUsers = async () => {
    const headersRequest = getHeaderForRequest();
    let allAdvertiseBannerUsers;
    try {
      allAdvertiseBannerUsers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/advertise/banner?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAdvertiseBannerUsers.data.data;
  };

  const getAllCampaignBanner = async () => {
    const allCampaignBanner = await sendRequestGetAllCampaignBanner();
    if (!allCampaignBanner) {
      return;
    }
    setAllCampaignBanner(
      await generateGetAllCampaignBannerTag(allCampaignBanner)
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const generateGetAllCampaignBannerTag = (allCampaignBanner) => {
    return allCampaignBanner.map((campaignBanner, index) => {
      return (
        <option key={index} value={campaignBanner.id}>
          {campaignBanner.title}
        </option>
      );
    });
  };

  const sendRequestGetAllCampaignBanner = async () => {
    const headersRequest = getHeaderForRequest();
    let allCampaignBanner;
    try {
      allCampaignBanner = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/banner/simple/advertise",
        headersRequest
      );
    } catch (error) {
      return false;
    }
    return allCampaignBanner.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const btnAddAdvertiseBannerClick = () => {
    document.querySelector("#select-campaign").classList.remove("d-none");
    document
      .querySelector("#select-campaign select")
      .classList.remove("d-none");
  };

  const selectCampaignUser = (e) => {
    const link = "/advertise/banner/add";
    const valueSelectBox = parseInt(e.target.value);
    if (valueSelectBox) {
      document
        .querySelector("#btn-add-advertise-banner")
        .classList.remove("d-none");
      setCampaignIDSelected(valueSelectBox);
    } else {
      document
        .querySelector("#btn-add-advertise-banner")
        .classList.add("d-none");
    }
  };

  const generateButtonAddAdvertise = () => {
    return (
      <div className="d-flex flex-column flex-lg-row pt-3">
        <div
          onClick={btnAddAdvertiseBannerClick}
          className="btn btn-success ml-2"
          to="/advertise/banner/add"
        >
          <span className="pl-2">
            <i className="fa fa-plus"></i>
          </span>
          <span>
            <span>اضافه کردن تبلیغ جدید به کمپین</span>
          </span>
        </div>
        <div
          className="ml-2 d-inline d-none py-2 py-lg-0 "
          id="select-campaign"
        >
          <select
            className="form-control d-none"
            onChange={(e) => {
              selectCampaignUser(e);
            }}
          >
            <option>کمپین خود را انتخاب کنید</option>
            {allCampaignBanner}
          </select>
        </div>
        <div className="d-none" id="btn-add-advertise-banner">
          <Link
            to={`/advertise/banner/add/` + campaignIDSelected}
            className="btn btn-success"
          >
            اضافه کردن
          </Link>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="all-advertise" activeItem="add-advertise-banner" />

      <div className="content-wrapper">
        <TitleBar title="تبلیغات بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning w-100 ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      هر تبلیغ فقط یک کمپین میتواند داشته باشد و هر کمپین فقط یک
                      تبلیغ میتواند داشته باشد.
                    </p>
                  </li>
                </ul>
              </div>

              <div>
                {allAdvertiseBannerUsers.length == 0
                  ? generateDoesNotHaveAnyAdvertiseTag()
                  : generateAllAdvertiseBannerUsers()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllBanner;
